export enum INPUT_MASKS {
  DDMMYYYY_DATE = '99/99/9999',
  CNPJ = '99.999.999/9999-99',
  CPF = '999.999.999-99',
  SMARTPHONE = '(99) 99999-9999',
  HHMMSS_TIME = '99:99:99',
}
